import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { Team } from '@repo/types';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 30 minutes frontend cache for team list query
const CACHE_TIME = 30 * 60 * 1000;

type QueryOptions = {
  variables?: Partial<{
    clubId?: string;
  }>;
  enabled?: boolean;
};

export const useTeamsQuery = (options?: QueryOptions) => {
  const { variables, ...queryOptions } = options ?? {};
  return useQuery({
    queryKey: ['teams', variables],
    queryFn: fetchTeams,
    staleTime: !accessToken ? CACHE_TIME : undefined,
    ...(queryOptions ?? {}),
  });
};

const fetchTeams: QueryFunction<Team[], [string, QueryOptions['variables']]> = async ({ queryKey }) => {
  const [, variables] = queryKey;
  const { data } = await axios.get<Team[]>(API.endpoints.teams, {
    params: variables ?? {},
  });
  return data;
};
